import React, { Component } from 'react'
import { Tooltip, Table } from 'antd'
import { app, config } from "../../app"
import common from "../review/common"
import api from "../../api"
import utils from "../../utils"

class HonorWallLogs extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }


    /**
     * 数据源
     * @param page
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setData({ data_loading: true, page })
        let { id } = this.props, { flag, data, msg, total } = await app.post(api.HAdminLogLists, {
            id,
            page,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({ dataList: utils.addArrayKey(data), data_loading: false, total: parseInt(total || 0) })
        }
    }

    setData = (data) => app.setStateSync(this, data)

    render () {
        let { data_loading, dataList, page, total } = this.state,
            columns = [
                {
                    title: '荣誉名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '15%',
                },
                {
                    title: '荣誉图片',
                    dataIndex: 'img',
                    key: 'img',
                    width: '15%',
                    render: (img) => {
                        return (
                            <a href={config.imgUrl + img} target="_blank">
                                <div className="hwmt-img">
                                    <img src={config.imgUrl + img} style={{
                                        maxWidth: '100%',
                                        maxHeight: '120px',
                                        width: 'auto',
                                        height: 'auto',
                                    }} alt="图片"/>
                                </div>
                            </a>
                        )
                    }
                },
                {
                    title: '荣誉分类',
                    dataIndex: 'category_name',
                    key: 'category_name',
                    width: '15%',
                },
                {
                    title: '荣誉类型',
                    dataIndex: 'type_name',
                    key: 'type_name',
                    width: '15%',
                },
                {
                    title: '修改时间',
                    dataIndex: 'updated_at',
                    key: 'updated_at',
                    width: '15%',
                },
                {
                    title: '审核状态',
                    dataIndex: 'is_audit',
                    key: 'is_audit',
                    width: '15%',
                    render: (audit, { audit_at, audit_by_name, audit_message, category_level }) => {
                        if (category_level === '3') {
                            return '无需审核'
                        }
                        return common.tableStatus(audit, audit_by_name, audit_at, audit_message)
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    width: '10%',
                    render: (remark) => {
                        return remark ? (
                            <Tooltip title={remark}><span
                                style={{ color: '#1890ff', cursor: 'pointer' }}>查看</span></Tooltip>
                        ) : ' - '
                    }
                }

            ]
        return (
            <div>
                <Table
                    columns={columns}
                    locale={app.tbLocale(data_loading)}
                    loading={data_loading}
                    dataSource={dataList}
                    scroll={{ y: 'calc(80vh - 170px)' }}
                    pagination={{
                        current: page,
                        total: total,
                        showTotal: (t) => `共${t}条.`,
                        pageSize: 20,
                        onChange: this.dataSource
                    }}
                    className="table-odd-even-row"
                    size="small"/>
            </div>
        )
    }
}

export default HonorWallLogs



// WEBPACK FOOTER //
// ./src/routes/ranks/HonorWallLogs.jsx